module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_three-8933bdcd60ca6230657c98e8f3c03f62.jpg";